<template>
  <div class="content">
    <ArtistSelect
      class="artist-selection"
      @memberChangeEvent="getArtistInfo"
      :include-unit-artist="true"
      :is-filter="true"
      :initial-unit-id="$route.query.unitId ? parseInt($route.query.unitId, 10) : null"
      :initial-member-id="$route.query.artistId ? parseInt($route.query.artistId, 10) : null"
    />
    <div v-if="memberId" class="row">
      <div class="col-sm-6" v-for="(item, index) in list">
        <CardLayout
          :key="index"
          :contentId="item.collectionId"
          :fileIds="item.fileIds"
          :title="item.title"
          :viewCount="item.viewCount"
          :commentCount="item.commentCount"
          :likeCount="item.likeCount"
          :pinCount="item.pinCount"
          :regDate="item.regTime"
          :btnDelete="true"
          :btnNotification="true"
          @sendNotification="sendNotification"
          @deleteContent="deleteArtistContent"
        />
      </div>
    </div>
  </div>
</template>
<script>
import ArtistSelect from "@/pages/Components/ArtistSelect.vue";
import CardLayout from "@/pages/Components/CardLayout.vue";
import { URLUtils } from "@/util/URLUtils";
import handlebars from "handlebars";
import swal from "sweetalert2";

const ARTISTBOARD_LOCATION = {
  SNS: 1,
  ARTIST_COLLECTION: 2,
};

const ARTISTBOARD_NOTIFICATION_TYPE = {
  ARTISTBOARD_UPDATE: 38,
  TRIVIA_UPDATE: 47,
};

export default {
  components: {
    ArtistSelect,
    CardLayout,
  },
  async created() {},
  data() {
    return {
      list: [],
      unitId: null,
      memberId: null,
      notification: {
        title: "[{{unitName}}] 이 갤러리로 입덕하신 분 찾아요 🖐",
        message: "{{memberName}}New 입덕 갤러리를 확인해보세요!",
        memberIds: [],
        notificationType: ARTISTBOARD_NOTIFICATION_TYPE.ARTISTBOARD_UPDATE,
      },
    };
  },
  methods: {
    async getArtistInfo(param) {
      this.unitId = param.unitId;
      this.unitName = param.unitName;
      this.memberId = param.memberId;
      this.memberName = param.memberName;
      this.isUnitArtist = param.isUnitArtist;
      await this.getData();
    },
    async getData() {
      const queryParams = {
        unitId: this.unitId,
        artistId: this.memberId || undefined,
      };
      const path = `/artistBoard/ipdokCollection?${URLUtils.objectToQueryString(queryParams)}`;
      if (this.$route.fullPath !== path) {
        try {
          await this.$router.push(path);
        } catch (ex) {}
      }
      return this.$axios
        .get("/artistBoard/collections", {
          params: { unitId: this.unitId, artistId: this.memberId },
        })
        .then((res) => {
          this.list = res.data.data;
          for (let i = 0; i < this.list.length; i++) {
            this.list[i].fileIds = [];
            for (let j = 0; j < this.list[i].medias.length; j++) {
              this.list[i].fileIds.push(this.list[i].medias[j].fileId);
            }
          }
        });
    },

    async sendNotification(param) {
      swal
        .fire({
          title: "알림 전송 확인",
          text: `알림을 전송하시겠습니까?`,
          type: "warning",
          showCancelButton: true,
          customClass: {
            confirmButton: "btn btn-danger btn-fill",
            cancelButton: "btn btn-cancel btn-fill",
          },
          confirmButtonText: "전송",
          cancelButtonText: "취소",
          buttonsStyling: false,
        })
        .then(async (selection) => {
          if (selection.value) {
            try {
              const collectionId = param.contentId;
              const titleTemplate = handlebars.compile(this.notification.title, { noEscape: true });
              const messageTemplate = handlebars.compile(this.notification.message, { noEscape: true });
              const memberName = this.isUnitArtist ? "" : `${this.memberName}의 `;
              this.notification.title = titleTemplate({ unitName: this.unitName, memberName });
              this.notification.message = messageTemplate({ unitName: this.unitName, memberName });
              this.notification.memberIds = this.isUnitArtist ? [] : [this.memberId];

              return this.$axios
                .put(`/artistBoard/${this.unitId}/notification`, {
                  params: { collectionId, focus: ARTISTBOARD_LOCATION.ARTIST_COLLECTION, ...this.notification },
                })
                .then((res) => {
                  Toast.success("전송완료");
                });
            } catch (err) {
              Toast.error("알림 전송 중 에러가 발생하였습니다.");
            }
          }
        });
    },

    async deleteArtistContent(param) {
      const collectionId = param.contentId;
      return this.$axios
        .delete("/artistBoard/collections", {
          params: { unitId: this.unitId, artistId: this.memberId, collectionId: collectionId },
        })
        .then((res) => {
          Toast.success("입덕 갤러리 삭제 되었습니다");
          this.getData();
        });
    },
  },
};
</script>
<style scopes lang="scss">
.artist-selection {
  margin-bottom: 20px;
}
</style>
